'use strict';

angular.module('shiftTraderApp')
  .directive('saOrgAttribute', function () {
    return {
      template: '<div data-ng-transclude></div>',
      transclude: true,
      scope: {
        attrName: '@',
        instantUpdate: '@',
        org: '=',
        loggedInUser: '=',
        textName: '@',
        debounce: '=?',
        callback: '=?'
      },
      controllerAs: 'vm',
      bindToController: true,
      restrict: 'A',
      controller: ['$scope', 'OrganizationSettings', 'toastr', function($scope, OrganizationSettings, toastr) {
        var vm = this;

        var oldValue = angular.copy(vm.org.organization_config[vm.attrName]);
        vm.data = { value: vm.org.organization_config[vm.attrName]};
        var requestProcessing = false;

        vm.updateAttribute = function () {
          requestProcessing = true;
          var data = {};
          data[vm.attrName] = vm.data.value;
          data.organization_id = vm.org.id;

          return OrganizationSettings.create(data)
            .then(function(response) {
              toastr.success(vm.textName + ' updated!', 'Success');
              return response;
            }, function() {
              vm.org.organization_config[vm.attrName] = oldValue;
              toastr.error(vm.textName + ' did not update correctly. Please try again.', 'Error');
              return undefined;
            });
        };

        vm.updateAttributeWithValue = function(val) {
          vm.data.value = val;
          return vm.updateAttribute();
        };

        if (vm.instantUpdate === 'true') {
          var watchFunction = function() {
            if (vm.data.value !== vm.org.organization_config[vm.attrName]) {
              if (!requestProcessing) {
                vm.updateAttribute()
                .then(function(response) {
                  requestProcessing = false;
                  if (!_.isUndefined(response)) {
                    vm.org.organization_config = response;
                    oldValue = angular.copy(vm.org.organization_config[vm.attrName]);
                  }

                  if (vm.callback) { vm.callback() }
                });
              }
            }
          }

          if (vm.debounce) {
            watchFunction = lodash.debounce(watchFunction, vm.debounce)
          }

          $scope.$watch('vm.data.value', watchFunction);
        }
      }]
    };
  });
